import { TextField as MuiTextField } from '@mui/material'
import { CSSProperties } from 'react'
// import MaskedInput from 'react-text-mask'

interface TextFieldProps {
  label?: string
  placeholder?: string
  type?: string
  style?: CSSProperties
  inputProps?: any
  mask?: string
  autoFocus?: boolean
  sx?: any
  multiline?: boolean
  rows?: number
  maxRows?: number
  onChange?: any
  value?: any
}

export const TextField = (props: TextFieldProps) => {
  const {
    label,
    placeholder,
    type,
    style,
    inputProps,
    // mask,
    autoFocus,
    sx,
    multiline,
    rows,
    maxRows,
    onChange,
    value
  } = props

  // if (mask) {
  //   return (
  //     <MuiTextField
  //       label={label}
  //       placeholder={placeholder}
  //       autoComplete="no"
  //       size="small"
  //       type={type}
  //       InputProps={{
  //         ...inputProps,
  //         inputComponent: (props: any) => (
  //           <MaskedInput
  //             ref={ref}
  //             {...props}
  //             mask={[
  //               /\d/,
  //               /\d/,
  //               /\d/,
  //               '.',
  //               /\d/,
  //               /\d/,
  //               /\d/,
  //               '.',
  //               /\d/,
  //               /\d/,
  //               /\d/,
  //               '-',
  //               /\d/,
  //               /\d/
  //             ]}
  //           />
  //         )
  //       }}
  //       style={{
  //         width: '100%',
  //         ...style
  //       }}
  //     />
  //   )
  // }

  return (
    <MuiTextField
      label={label}
      onChange={onChange}
      value={value}
      placeholder={placeholder}
      autoComplete="no"
      size="small"
      type={type}
      multiline={multiline}
      inputProps={inputProps}
      autoFocus={autoFocus}
      rows={rows}
      maxRows={maxRows}
      style={{ width: '100%', ...style }}
      sx={sx}
    />
  )
}

TextField.defaultProps = {
  autoFocus: false,
  type: 'text',
  multiline: false,
  rows: 1
}
